import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ModulesMangosI } from '../../interfaces/modules-mango.interface';

@Component({
  selector: 'mg-popover',
  templateUrl: './popover-modules.component.html',
  styleUrls: ['./popover-modules.component.scss'],
})
export class PopoverModulesComponent implements OnInit {
  @Input() elements: ModulesMangosI[] = [];
  @Output() elementSelected: EventEmitter<any> = new EventEmitter();
  @Output() closePopover: EventEmitter<any> = new EventEmitter();
  some_text = '';
  inside = false;
  constructor() {}

  ngOnInit(): void {}

  @HostListener('click')
  clicked() {
    this.inside = true;
  }

  @HostListener('document:click')
  clickedOut() {
    this.some_text = this.inside
      ? 'Event Triggered'
      : 'Event Triggered Outside Component';
    if (!this.inside) {
      this.closePopover.emit(this.inside);
    }
    this.inside = false;
  }

  selected(item: ModulesMangosI) {
    this.elementSelected.emit(item);
  }
}
